import React from 'react';
import { observer } from 'mobx-react';
import Popover from 'react-bootstrap/Popover';
import Overlay from 'react-bootstrap/Overlay';

@observer
class ErrorMessage extends React.Component {

    constructor(props) {
        super(props);
        this.anchorRef = React.createRef();
        this.getTarget = this.getTarget.bind(this);
    }

    // Anchor the popover to the field's input so Popper measures real space around it;
    // fall back to the zero-height anchor if no input is found in the field container.
    getTarget() {
        const anchor = this.anchorRef.current;
        const container = anchor?.parentElement?.parentElement;
        return container?.querySelector('input, select, textarea') || anchor;
    }

    render() {
        return (
            <>
            {this.props.value &&
            <div className="small errorMessageComponent">
                {this.props.showPopoverError===true ?
                <>
                <div ref={this.anchorRef} style={{width: "100%", position: "absolute", height: '0px'}}></div>
                <Overlay
                    show={true}
                    target={this.getTarget}
                    placement={"top"}
                    flip={true}
                    popperConfig={{
                        modifiers: [
                            { name: 'flip', options: { fallbackPlacements: ['bottom', 'right', 'left'] } },
                            { name: 'preventOverflow', options: { padding: 4 } },
                        ],
                    }}
                >
                    <Popover className="errorMessageComponentPopover">
                        <Popover.Content className="first-upper" style={{minWidth: "180px"}}>
                        {this.props.value}
                        </Popover.Content>
                    </Popover>
                </Overlay>
                </>
                :
                <><div className="first-upper" style={{  bottom: "0"}}>{this.props.value}</div></>
            }
            </div>
            }
            </>
        );
    }
}

export { ErrorMessage };
